import styled from "styled-components";

export const ReadyGameConfigSelect = styled.select`
  /* all: unset; */
  border: 1px solid #ffffff90;
  background-color: #ffffff60;
  border-radius: 1rem;
  font-size: 4.5rem;
  padding: 1rem;
  width: 100%;
`

export const ReadyGameConfigInput = styled.input`
  all: unset;
  border: 1px solid #ffffff90;
  background-color: #ffffff60;
  font-size: 4.5rem;
  border-radius: 1rem;
  padding: 1rem;
  box-sizing: border-box;
  width: 100%;
`

export const ReadyGameConfigLabel = styled.label`
  font-size: 5rem;
  font-weight: 800;
`

export const ReadyGameConfigInputDescription = styled.span`
  font-size: 3.5rem;
  color: #00000099;
`

export const ReadyGameConfigInputMetadataBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`